import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {TokenService} from './token.service';
import {GeneralConstant} from '../constants/GeneralConstant';
import {RestResponse} from '../models/http/RestResponse.model';
import {RouteUrls} from '../constants/RouteUrls';
import {UrlEncoder} from '@ucx/ui-lib';

@Injectable()
export class HttpCallsInterceptor implements HttpInterceptor {

  constructor(private tokenService: TokenService, private router: Router) {
  }

  /**
   * Add headers to requests that are made through the HttpClient
   * @param req: HttpRequest
   */
  addHeaders(req: HttpRequest<any>): HttpRequest<any> {
    const token = this.tokenService.getToken();
    if (req.headers.has(GeneralConstant.SKIP_TOKEN)) {
      return req.clone({
        headers: req.headers.delete(GeneralConstant.SKIP_TOKEN)
      });
    } else {
      return req.clone({
        setHeaders: {
          Authorization: token,
          'X-Timezone-Offset': this.getTimezoneOffset()
        }
      });
    }
  }

  /**
   * Interecpt all the outgoing requests and their responses.
   * @param req: HttpRequest
   * @param next: HttpHandler
   */

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Encode params with special characters...
    if (req.params.toString().includes('+')) {
      req = req.clone({params: new HttpParams({encoder: new UrlEncoder(), fromString: req.params.toString()})});
    }
    return next.handle(this.addHeaders(req)).pipe(
      catchError(err => {
        const error = err as HttpErrorResponse;
        if (this.tokenService.isAuthenticated() && error.status === 406) {
          if (this.tokenService.isTokenExpired()) {
            return this.tokenService.refreshToken().pipe(
              map(response => {
                this.onSuccessfulTokenRefresh(response);
              }),
              mergeMap(() => {
                return this.intercept(req, next);
              })
            );
          } else {
            return this.intercept(req, next);
          }
        } else if (error.status === 403) {
          this.router.navigateByUrl(RouteUrls.LOGOUT);
        }
        return throwError(err);
      })
    );

  }

  /**
   * Refresh token if it has expired.
   * @param result: RestResponse
   */
  private onSuccessfulTokenRefresh(result: RestResponse<any>) {
    const response = result.data;
    const token = response.token;
    const refreshToken = response.refreshToken;
    this.tokenService.saveToken(token);
    this.tokenService.saveRefreshToken(refreshToken);
  }

  private getTimezoneOffset(): string {
    return (String(new Date().getTimezoneOffset() / 60));
  }
}
